interface Holder {
  cf?: string | null;
  cognomeNome?: string | null;
  denominazione?: string | null;
  diritto?: string | null;
  quotaNum?: string | null;
  quotaDen?: string | null;
}
interface Property {
  indirizzo: string | null;
  comune: string | null;
  foglio: string | null;
  particella: string | null;
  subalterno: string | null;
  titolari: Holder[];
}
export interface DocumentedConnection {
  nome: string;
  cf: string | null;
  immobili: Array<{indirizzo:string; riferimento:string; diritto:string; quota:string}>;
}
export function buildDocumentedConnections(immobili: Property[], deceasedCf: string | null, deceasedName?: string | null): DocumentedConnection[] {
  const people = new Map<string, DocumentedConnection>();
  const deceased = deceasedCf?.replace(/\s+/g,'').toUpperCase();
  for (const im of immobili) {
    const seen = new Set<string>();
    for (const t of im.titolari) {
      const cf=t.cf?.replace(/\s+/g,'').toUpperCase() || null;
      if (cf && cf===deceased) continue;
      const nome=t.cognomeNome || t.denominazione || '';
      if (!deceased && deceasedName && sameName(tokens(nome),tokens(deceasedName))) continue;
      if(!cf && !nome) continue;
      const key=cf || `nome:${nome.toUpperCase()}`;
      if(seen.has(key)) continue;
      seen.add(key);
      const person=people.get(key) ?? {nome,cf,immobili:[]};
      person.immobili.push({indirizzo:im.indirizzo || im.comune || 'Indirizzo non disponibile',riferimento:[im.comune,im.foglio && `foglio ${im.foglio}`,im.particella && `particella ${im.particella}`,im.subalterno && `sub ${im.subalterno}`].filter(Boolean).join(' · '),diritto:t.diritto || 'Diritto non indicato',quota:t.quotaNum && t.quotaDen ? `${t.quotaNum}/${t.quotaDen}` : 'Non indicata'});
      people.set(key,person);
    }
  }
  return [...people.values()].sort((a,b)=>b.immobili.length-a.immobili.length);
}
export const documentedConnectionsNote='Si vedono solo gli immobili della visura del defunto. Un familiare compare qui soltanto se risulta già cointestatario su quegli immobili. Non è l’elenco degli eredi e non include le proprietà che i familiari hanno solo a nome proprio.';
function fold(value:string):string {
 return value.normalize('NFD').replace(/\p{M}/gu,'').replace(/[’‘ʼ`´]/g,"'").toUpperCase().replace(/[^A-Z0-9' ]+/g,' ').replace(/\s+/g,' ').trim();
}
function tokens(value:string):string[] {
 return fold(value).split(' ').filter(t=>t.length>0&&!/^\d/.test(t));
}
function sameName(a:string[],b:string[]):boolean {
 return a.length===b.length && [...a].sort().join('|')===[...b].sort().join('|');
}
export interface FamilyHolderMatch {holderName:string;immobili:number}
export function matchFamilyToHolders(people:Array<{name:string;surname:string|null;uncertain?:boolean}>,immobili:Property[],deceasedCf:string|null,deceasedName?:string|null):Array<FamilyHolderMatch|null> {
 const holders=buildDocumentedConnections(immobili,deceasedCf,deceasedName);
 return people.map(person=>{
  const given=tokens(person.name);
  const sur=tokens(person.surname??'');
  if(!given.length||!sur.length||person.uncertain)return null;
  const hits=holders.filter(h=>{
   const ht=tokens(h.nome);
   return sameName([...given,...sur],ht);
  });
  if(hits.length===1)return {holderName:hits[0].nome,immobili:hits[0].immobili.length};
  return null;
 });
}
export function familyMentions(text: string | null): string[] {
  if(!text)return [];
  const source=text.replace(/\s+/g,' ').trim();
  const family='(?:figli[oaie]?|fratell[oi]|sorell[ae]|nipot[ei])';
  const pattern=new RegExp(`\\b(?:il|la|i|le|gli)\\s+${family}\\b[\\s\\S]*?(?=,?\\s+(?:il|la|i|le|gli)\\s+${family}\\b|[.;]|$)`,'gi');
  return [...new Set([...source.matchAll(pattern)].map(m=>m[0].replace(/[,\s]+$/,'').trim()).filter(fragment=>fragment.length<=180))].slice(0,8);
}
